export const SESSION_TRACKING_ENTRY_ID = 'ibe.ste';